<template>
  <form class="app-login-form" @submit.prevent="onSubmit()">
    <div class="inputs-container">
      <div class="inputs-container__inputs">
        <app-input
          v-mask="'###.###.###-##'"
          v-model="cpf"
          label="CPF"
        ></app-input>
        <app-input v-model="password" label="Senha" type="password"></app-input>
      </div>
      <div class="inputs-container__forgot">
        <a @click="showDialog()">Esqueci minha senha</a>
      </div>
    </div>
    <div class="buttons-container">
      <button :disabled="$v.$invalid || isLoading" type="submit" v-app-button>
        Entrar
      </button>
      <button
        @click="onFirstAccess()"
        :disabled="!cpf"
        type="button"
        v-app-button.outline
      >
        PRIMEIRO ACESSO
      </button>
    </div>
  </form>
</template>

<script>
import { AUTH_REQUEST, AUTH_FIRST } from '@/store/actions/auth';
import NewPasswordModal from '@/components/Modal/NewPasswordModal.vue';
import RequestNewPasswordModal from '@/components/Modal/RequestNewPasswordModal.vue';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'app-login-form',
  data: () => {
    return {
      cpf: null,
      password: null,
      isLoading: false,
    };
  },
  validations: {
    cpf: { required },
    password: { required },
  },
  methods: {
    onSubmit() {
      if (this.$v.$invalid) return;

      const { cpf, password } = this;
      this.isLoading = true;

      this.$store
        .dispatch(AUTH_REQUEST, { cpf, password })
        .then(({ isNew }) => {
          if (process.env.NODE_ENV === 'production') {
            this.$gtag.event('login', { cpf });
          }

          if (isNew) {
            setTimeout(() => {
              this.$buefy.modal.open({
                parent: this,
                component: NewPasswordModal,
                trapFocus: true,
                hasModalCard: true,
              });
            }, 500);
          }
        })
        .catch(({ response }) => {
          if (response.status === 401)
            this.toastify('Dados inválidos. Tente novamente.', 'error');
        })
        .finally(() => (this.isLoading = false));
    },
    onFirstAccess() {
      this.$store
        .dispatch(AUTH_FIRST, this.cpf)
        .then(() => setTimeout(() => this.$router.push('/first-access')))
        .catch((error) => {
          const { status, data } = error.response;

          if (status === 401) this.toastify(data.message, 'info');
          else
            this.toastify(
              'Não encontramos o CPF informado nos nossos registros.',
              'error'
            );
        });
    },
    showDialog() {
      this.$buefy.modal.open({
        parent: this,
        component: RequestNewPasswordModal,
        trapFocus: true,
        hasModalCard: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-login-form {
  display: flex;
  align-items: center;

  .inputs-container {
    &__inputs {
      display: flex;

      .app-input {
        margin-bottom: 0;
        margin-right: 12px;

        input {
          height: 48px;
        }
      }
    }

    &__forgot {
      text-align: right;
      margin-right: 12px;

      a {
        font-size: 0.8em;
        color: var(--color-text-light);

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .buttons-container {
    padding-top: 12px;

    button {
      margin: 0 8px;
      height: 48px;
    }
  }
}

@media (max-width: 992px) {
  .app-login-form {
    width: 100%;
  }
}
</style>
